import { QueryClient } from '@tanstack/react-query'

/**
 * TanStack Query 客户端配置
 * 
 * 缓存策略：
 * - staleTime: 5 分钟 - 数据在此期间被视为新鲜，不会重新获取
 * - gcTime: 24 小时 - 未使用的缓存数据在此期间后被垃圾回收
 * - refetchOnWindowFocus: false - 窗口聚焦时不自动刷新
 * - refetchOnReconnect: true - 网络恢复时刷新数据
 */
export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      // 数据过期时间（5 分钟）- 在此期间数据被视为新鲜
      staleTime: 5 * 60 * 1000,
      // 垃圾回收时间（24 小时）- 未使用的缓存数据保留时间
      gcTime: 24 * 60 * 60 * 1000,
      // 重试次数
      retry: 1,
      // 窗口聚焦时不重新获取
      refetchOnWindowFocus: false,
      // 网络恢复时重新获取
      refetchOnReconnect: true,
    },
    mutations: {
      // 变更操作不重试
      retry: 0,
    },
  },
})
